export const FETCH_RELATIONS = 'FETCH_GRAPH_RELATIONS';
export const FAILED_RELATIONS = 'FAILED_GRAPH_RELATIONS';
export const RECEIVED_RELATIONS = 'RECEIVED_GRAPH_RELATIONS';

export const EDIT_RELATIONS = 'EDIT_GRAPH_RELATIONS';
export const EDITED_RELATIONS = 'EDITED_RELATIONS';

export const ERROR_RECEIVED_FROM_API = 'GRAPHAPI_ERROR_RECEIVED_FROM_API';
